// client/src/redux/reducers/companyReducer.js
// Types d'actions
export const FETCH_COMPANIES_REQUEST = 'FETCH_COMPANIES_REQUEST';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_FAILURE = 'FETCH_COMPANIES_FAILURE';

export const FETCH_COMPANY_REQUEST = 'FETCH_COMPANY_REQUEST';
export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';
export const FETCH_COMPANY_FAILURE = 'FETCH_COMPANY_FAILURE';

export const CREATE_COMPANY_REQUEST = 'CREATE_COMPANY_REQUEST';
export const CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS';
export const CREATE_COMPANY_FAILURE = 'CREATE_COMPANY_FAILURE';

export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_FAILURE = 'UPDATE_COMPANY_FAILURE';

export const DELETE_COMPANY_REQUEST = 'DELETE_COMPANY_REQUEST';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS';
export const DELETE_COMPANY_FAILURE = 'DELETE_COMPANY_FAILURE';

export const CLEAR_COMPANY_ERRORS = 'CLEAR_COMPANY_ERRORS';

// État initial
const initialState = {
  companies: null,
  company: null,
  loading: false,
  error: null
};

// Reducer
const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMPANIES_REQUEST:
    case FETCH_COMPANY_REQUEST:
    case CREATE_COMPANY_REQUEST:
    case UPDATE_COMPANY_REQUEST:
    case DELETE_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.payload,
        loading: false,
        error: null
      };
    
    case FETCH_COMPANY_SUCCESS:
      return {
        ...state,
        company: action.payload,
        loading: false,
        error: null
      };
    
    case CREATE_COMPANY_SUCCESS:
      return {
        ...state,
        companies: state.companies ? {
          ...state.companies,
          items: [action.payload, ...(state.companies.items || [])]
        } : state.companies,
        loading: false,
        error: null
      };
    
    case UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        companies: state.companies ? {
          ...state.companies,
          items: state.companies.items?.map(company =>
            company.id === action.payload.id ? action.payload : company
          )
        } : state.companies,
        company: action.payload,
        loading: false,
        error: null
      };
    
    case DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        companies: state.companies ? {
          ...state.companies,
          items: state.companies.items?.filter(company => 
            company.id !== action.payload
          )
        } : state.companies,
        loading: false,
        error: null
      };
    
    case FETCH_COMPANIES_FAILURE:
    case FETCH_COMPANY_FAILURE:
    case CREATE_COMPANY_FAILURE:
    case UPDATE_COMPANY_FAILURE:
    case DELETE_COMPANY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case CLEAR_COMPANY_ERRORS:
      return {
        ...state,
        error: null
      };
    
    default:
      return state;
  }
};

export default companyReducer;